import * as React from "react"
import type { SVGProps } from "react"
const SvgStairs = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M3 19.86a1 1 0 0 1-.71-.29 1 1 0 0 1-.29-.71q0-.43.29-.72a1 1 0 0 1 .71-.28h5v-5q0-.43.29-.72a1 1 0 0 1 .71-.28h5v-5q0-.43.29-.72a1 1 0 0 1 .71-.28h6q.42 0 .71.28.3.3.29.72 0 .42-.29.71a1 1 0 0 1-.71.29h-5v5q0 .42-.29.71a1 1 0 0 1-.71.29h-5v5q0 .42-.29.71a1 1 0 0 1-.71.29z" />
  </svg>
)
export default SvgStairs
